import React from 'react'
import { DateRangePicker } from 'react-dates'
import { withTranslation as translate } from 'react-i18next'
import moment from 'moment'
import "moment/locale/en-gb"
import "moment/locale/sv"
import "moment/locale/da"
import "moment/locale/de"
import "moment/locale/es"
import "moment/locale/fr"
import "moment/locale/hr"
import "moment/locale/nn"

import utils from '../lib/utils.js'
import ReactDOM from 'react-dom';
// Rename to DateRangePicker?

class DatePicker extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      focusedInput: this.props.preOpen? 'endDate' : null,
      openDatePicker: false
    }
    this.handleClickCloseBtn = this.handleClickCloseBtn.bind(this)
    this.handleClick= this.handleClick.bind(this)
    this.renderCalendarInfo =this.renderCalendarInfo.bind(this)
    this.isOutsideRange = this.isOutsideRange.bind(this)
    this.onDatesChange = this.onDatesChange.bind(this)
    this.onFocusChange = this.onFocusChange.bind(this)
    this.isDayBlocked = this.isDayBlocked.bind(this)
  }
  componentDidMount(){
    if (!this.props.smallScreen === true){
      document.addEventListener('mousedown', this.handleClick, false)
    } else {
      document.addEventListener('mousedown', this.handleClickCloseBtn, false)
    }
    if(document.getElementsByClassName('DayPicker_focusRegion DayPicker_focusRegion_1')[0]){
      document.getElementsByClassName('DayPicker_focusRegion DayPicker_focusRegion_1')[0].setAttribute('aria-label','Calendar for day picking')
    }
    moment.locale(this.props.i18n.language);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
    document.removeEventListener('mousedown', this.handleClickCloseBtn, false)
  }
  componentDidUpdate(){
    if(this.props.endDate && this.props.startDate){
      let duration = moment.duration(this.props.endDate.diff(this.props.startDate));
      let diffNights = duration.asDays();
      this.setState({
        startDate: this.props.startDate? moment(this.props.startDate).format('MMMM Do YYYY'): null,
        endDate: this.props.endDate? moment(this.props.endDate).format('MMMM Do YYYY'): null,
        diffNights: diffNights
      })
    }
    if(document.getElementsByClassName('DayPicker_focusRegion DayPicker_focusRegion_1')[0]){
      document.getElementsByClassName('DayPicker_focusRegion DayPicker_focusRegion_1')[0].setAttribute('aria-label','Calendar for day picking')
    } 
    if(this.props.openDatePicker && !this.state.openDatePicker){
      this.setState({openDatePicker: true, focusedInput: 'startDate'})
    } 
    else if(!this.props.openDatePicker && this.state.openDatePicker){
      this.setState({openDatePicker: false, focusedInput: null})
    }
    moment.locale(this.props.i18n.language);
  }
  onDatesChange({ startDate, endDate }) {
    if (this.props.smallScreen) {
      document.body.style.overflow = "scroll";
    }
    if (!this.props.smallScreen === true){
      this.setState(
        {
          focusedInput: startDate && !endDate ? 'endDate' : 'startDate'
        },
        () => {
          if (this.props.onDatesChange) {
            this.props.onDatesChange({
              startDate: startDate ? startDate.clone().startOf('day') : null,
              endDate: endDate ? endDate.clone().startOf('day') : null
            })
          }
        }
      )
    }
    this.setState(
      {
        focusedInput: startDate && !endDate ? 'endDate' : null
      },
      () => {
        if (this.props.onDatesChange) {
          this.props.onDatesChange({
            startDate: startDate ? startDate.clone().startOf('day') : null,
            endDate: endDate ? endDate.clone().startOf('day') : null
          })
        }
      }
    )
  }

  isOutsideRange(mom) {
    let today = moment().startOf('day')
    if (this.props.availability) {
      let endBoundary = moment()
        .add(this.props.availability.length, 'days')
        .startOf('day')
      return mom.isBefore(today, 'day') || mom.isAfter(endBoundary, 'day')
    }
    else if (this.props.futureOnly){
      return mom.isBefore(today, 'day')
    }
    else {
      return false
    }
  }

  isDayBlocked(mom) {
    if (!this.props.availability) {
      return false
    }

    if (!mom) {
      return true
    }

    const date = utils.getDateString(mom)
    let avail = this.props.availability.find(a => a.date === date)
    if (!avail) {
      return true
    }

    return !avail.is_available
  }

  onFocusChange(focusedInput) {
    // There is a bug in react-dates that makes the enddate defocus on mobile.
    // https://github.com/airbnb/react-dates/issues/761
    // This if clause is a hackfix until it's fixed in the lib
    if (
      !this.props.endDate &&
      this.state.focusedInput === 'endDate' &&
      focusedInput === 'startDate'
    ) {
      this.setState({ focusedInput: null })
      return
    }

    if (this.state.focusedInput === null) {
      this.setState({ focusedInput })
    }
  }
  handleClickCloseBtn(e){
    if (this.props.smallScreen) {
      document.body.style.overflow = "scroll";
    }
    if (e.target.className === 'DateRangePicker_closeButton DateRangePicker_closeButton_1' ||
    e.target.parentNode.classList[0] == 'DateRangePicker_closeButton' ||
    e.target.parentNode.classList[0] == 'DateRangePicker_closeButton_svg'
    ){
      this.setState({focusedInput: null})
    }
  }
  handleClick(e){
    if (this.node && this.node.contains(e.target)){
      return
    } else {
      this.setState({focusedInput: null})
    }
    
  }
  renderCalendarInfo(){
    const _t = this.props.t
    if (this.props.smallScreen) {
      document.body.style.overflow = "hidden";
    }
    let info = <div className="calendar-info-wrapper"><div className="calendar-info">{_t("calendar_date_info_1", "select Check-In and Check-Out dates")}</div></div>
    if (this.state.diffNights > 0){
      // info = <div className="calendar-info-wrapper"><div className="calendar-info">{this.state.startDate? this.state.startDate : null} - {this.state.endDate? this.state.endDate : null} {Math.ceil(this.state.diffNights)}-nights stay</div></div>
      info = <div className="calendar-info-wrapper"><div className="calendar-info">{Math.ceil(this.state.diffNights)}-{_t("calendar_date_info_2", "night(s) stay")}</div></div>
    }
    return (
      info
    )
  }
  render() {
    // Date picker has issues rendering on server side, we may reevealuatre this at a later date.
    if(window.isServerSide) return <></>;
    const _t = this.props.t
    let className = 'date-picker'
    if (this.props.className) {
      className += ' ' + this.props.className
    }

    let minimumNights = 1
    if (this.props.minimumNights !== undefined) {
      minimumNights = this.props.minimumNights
    }

    let orientation = 'horizontal'
    let fullScreen = false
    if (this.props.smallScreen) {
      orientation = 'vertical'
      fullScreen = true
    }
    const openDirection = (this.props.openDirection) ? this.props.openDirection : 'down';
    return (
      <div
        className={className}
        style={this.props.style ? this.props.style : null}
        ref={node => this.node = node }
      >
        <DateRangePicker
          disabled={this.props.disabled}
          startDateId="startDate"
          endDateId="endDate"
          startDate={this.props.startDate? this.props.startDate: moment(new Date())}
          endDate={this.props.endDate}
          showDefaultInputIcon={true}
          minimumNights={minimumNights}
          onClose={this.props.onCalendarClose}
          isOutsideRange={this.isOutsideRange}
          isDayHighlighted={this.isDayBlocked}
          onDatesChange={this.onDatesChange}
          focusedInput={this.state.focusedInput}
          onFocusChange={this.onFocusChange}
          orientation={orientation}
          withFullScreenPortal={fullScreen}
          displayFormat="YYYY-MM-DD"
          startDatePlaceholderText = {_t('calendar_date_start')}
          endDatePlaceholderText = {_t('calendar_date_end')}
          openDirection={openDirection}
          renderCalendarInfo={this.renderCalendarInfo}
          hideKeyboardShortcutsPanel={true}
          keepOpenOnDateSelect={true}
        />
      </div>
    )
  }
}

export default translate()(DatePicker)
